// Brand constants for Madison Peaceful Path Home Care
export const BRAND = {
  name: "Madison Peaceful Path Home Care",
  shortName: "Peaceful Path",
  llc: "Madison Peaceful Path Home Care LLC",
  phone: "608-513-7639",
  phoneRaw: "+16085137639",
  email: "info@madisonpeacefulpath.com",
  domain: "madisonpeacefulpath.com",
  city: "Madison, Wisconsin",
  tagline:
    "Compassionate In-Home Care Rooted in Dignity, Consistency, and Peace of Mind.",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why-us" },
  { label: "Process", href: "#process" },
  { label: "Caregivers", href: "#careers" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    icon: "Heart",
    title: "Companionship Care",
    blurb:
      "Meaningful conversation, shared activities, and a warm presence so no one feels alone at home.",
  },
  {
    icon: "Hand",
    title: "Personal Care Assistance",
    blurb:
      "Respectful help with bathing, grooming, dressing, and hygiene — always with dignity first.",
  },
  {
    icon: "Brain",
    title: "Dementia & Memory Support",
    blurb:
      "Patient, specialized care for Alzheimer's and dementia using calming, familiar routines.",
  },
  {
    icon: "Coffee",
    title: "Respite Care",
    blurb:
      "Trusted relief for family caregivers — take a breath while we care for your loved one.",
  },
  {
    icon: "Utensils",
    title: "Meal Preparation",
    blurb:
      "Nutritious, home-cooked meals tailored to dietary needs and personal preferences.",
  },
  {
    icon: "Pill",
    title: "Medication Reminders",
    blurb:
      "Gentle, on-time reminders so prescriptions are never missed or doubled.",
  },
  {
    icon: "Car",
    title: "Transportation Assistance",
    blurb:
      "Safe rides to appointments, errands, church, and family gatherings around Madison.",
  },
  {
    icon: "Footprints",
    title: "Mobility Assistance",
    blurb:
      "Steady, attentive support with walking, transfers, and fall prevention at home.",
  },
  {
    icon: "Home",
    title: "Light Housekeeping",
    blurb:
      "A tidy, calm home — laundry, dishes, dusting, and bed-making done with care.",
  },
  {
    icon: "Stethoscope",
    title: "Post-Hospital Support",
    blurb:
      "Compassionate recovery care after a hospital stay to prevent setbacks and promote healing.",
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Submit A Care Request",
    body: "Share a few details about your loved one — takes about 3 minutes.",
  },
  {
    num: "02",
    title: "Phone Consultation",
    body: "We listen carefully, answer your questions, and explore what's needed.",
  },
  {
    num: "03",
    title: "In-Home Assessment",
    body: "A relaxed home visit to understand routine, preferences, and environment.",
  },
  {
    num: "04",
    title: "Personalized Care Plan",
    body: "A thoughtful plan tailored to your family — no templates, no shortcuts.",
  },
  {
    num: "05",
    title: "Care Begins",
    body: "Your matched caregiver arrives — consistent, kind, and dependable.",
  },
];

export const FAQS = [
  {
    q: "How much does home care cost?",
    a: "Cost depends on the level of care, hours per week, and any specialized support needed (such as dementia care). After your free phone consultation and in-home assessment, we'll provide a transparent quote with no hidden fees. Many families are surprised at how flexible and affordable thoughtful home care can be.",
  },
  {
    q: "How quickly can care begin?",
    a: "In many cases we can start care within 48–72 hours of your assessment. For urgent post-hospital situations or family emergencies, we move even faster — sometimes within 24 hours.",
  },
  {
    q: "Do you provide dementia and Alzheimer's support?",
    a: "Yes. Our caregivers are specifically trained in dementia-informed care — calming routines, redirection, sensory engagement, and patient communication that always preserves dignity and identity.",
  },
  {
    q: "Can we request the same caregiver every visit?",
    a: "Absolutely — that's our standard practice. Consistency is the heart of our model. The same trusted caregiver returns each visit, building a real relationship with your loved one.",
  },
  {
    q: "What happens during the first consultation?",
    a: "A free, no-obligation phone conversation. We listen carefully, learn about your loved one, answer your questions, and explore what kind of support would help most. There's no pressure to commit to anything.",
  },
  {
    q: "What areas do you serve?",
    a: "Madison and surrounding communities throughout Dane County, Wisconsin. If you're nearby and unsure, give us a call — we'll let you know honestly.",
  },
  {
    q: "How are caregivers selected and matched?",
    a: "Every caregiver is background-checked, interviewed, and trained before joining our team. We then thoughtfully match each caregiver to your family based on personality, lifestyle, language, cultural background, and care needs — so the relationship feels natural from day one.",
  },
  {
    q: "Is this medical or non-medical home care?",
    a: "We provide non-medical home care: companionship, personal care, light housekeeping, medication reminders, mobility help, and more. We coordinate seamlessly with medical providers when needed.",
  },
  {
    q: "What is respite care and when do I need it?",
    a: "Respite care gives family caregivers a chance to rest. Whether you need a few hours, a weekend, or a full week — we step in so you can recharge without worry.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "From the first phone call, they listened. The caregiver they matched with my mother feels like family now — and Mom is calmer, brighter, more herself.",
    name: "Renee J.",
    role: "Daughter of client",
  },
  {
    quote:
      "After Dad's hospital stay, we needed help fast. Peaceful Path showed up with kindness, professionalism, and a real plan. They lifted a weight off our shoulders.",
    name: "Marcus T.",
    role: "Family member",
  },
  {
    quote:
      "Consistency was everything for us. The same caregiver, every week. My grandmother trusts her — and so do we.",
    name: "Aisha K.",
    role: "Granddaughter of client",
  },
];

export const KEYWORDS = [
  "Home Care Madison WI",
  "In-Home Care Madison Wisconsin",
  "Senior Care Madison WI",
  "Caregiver Services Madison WI",
  "Dementia Care Madison WI",
  "Companion Care Madison WI",
  "Private Pay Home Care Madison",
  "Non-Medical Home Care Madison",
];
